var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 1C21.1422 1 22.8911 2.68397 22.9951 4.80036L23 5V19C23 21.1422 21.316 22.8911 19.1996 22.9951L19 23H15C14.4477 23 14 22.5523 14 22C14 21.4872 14.386 21.0645 14.8834 21.0067L15 21H19C20.0544 21 20.9182 20.1841 20.9945 19.1493L21 19V5C21 3.94564 20.1841 3.08183 19.1493 3.00549L19 3H15C14.4477 3 14 2.55228 14 2C14 1.48716 14.386 1.06449 14.8834 1.00673L15 1H19ZM10.6129 7.2097L10.7071 7.29289L15.4142 12L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071C8.93241 16.3466 8.90468 15.7794 9.2097 15.3871L9.29289 15.2929L11.584 13H2C1.44772 13 1 12.5523 1 12C1 11.4872 1.38604 11.0645 1.88338 11.0067L2 11H11.584L9.29289 8.70711C8.93241 8.34662 8.90468 7.77939 9.2097 7.3871L9.29289 7.29289C9.65338 6.93241 10.2206 6.90468 10.6129 7.2097Z",
    fill: "#FF435A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/log_out.eb377d0f39f60455c5d9746df10faa29.svg";
export { ForwardRef as ReactComponent };